export default "__VITE_ASSET__h5U07FYo__"